import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { MembershipPlans_Api } from "../../../MiddleWare/Apis/MembershipApi";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import {
  MembershipWrapper,
  MembershipContainer,
  MembershipHeader,
  MembershipTitle,
  ViewAllText,
  MembershipTable,
  TableHeader,
  HeaderText,
  TableRow,
  PlanNameText,
  CellText,
  StatusBadge,
  MobileLabel,
  MobileCell,
} from "./styles";

const MembershipPlan = () => {
  const navigate = useNavigate();
  const [membershipData, setMembershipData] = useState([]);

  useEffect(() => {
    getMembershipPlans();
  }, []);

  const getMembershipPlans = async () => {
    try {
      const res = await MembershipPlans_Api();

      if (res.status === 200) {
        const decryptedData = Decrypt_Value(res.data, "vozoportalapp");

        let plans = [];

        if (Array.isArray(decryptedData)) {
          plans = decryptedData;
        } else if (decryptedData && Array.isArray(decryptedData.data)) {
          plans = decryptedData.data;
        }

        const formattedPlans = plans.map((item) => ({
          id: item.id,
          planName: item.plan_name || "-",
          description: item.description || "-",
          startDate: item.start_date || "-",
          endDate: item.end_date || "-",
          status: item.status || "-",
        }));

        setMembershipData(formattedPlans);
      } else {
        setMembershipData([]);
      }
    } catch (error) {
      console.log(error.message);
      setMembershipData([]);
    }
  };

  return (
    <MembershipWrapper>
      <MembershipContainer>
        <MembershipHeader>
          <MembershipTitle>Membership Plan</MembershipTitle>
          <ViewAllText onClick={() => navigate("/membership-plan")}>
            View All →
          </ViewAllText>
        </MembershipHeader>

        <MembershipTable>
          <TableHeader>
            <HeaderText>Plan Name</HeaderText>
            <HeaderText>Description</HeaderText>
            <HeaderText>Start Date</HeaderText>
            <HeaderText>End Date</HeaderText>
            <HeaderText>Status</HeaderText>
          </TableHeader>

          {membershipData.length > 0 ? (
            membershipData.slice(0, 3).map((item) => (
              <TableRow key={item.id}>
                <div>
                  <MobileCell>
                    <MobileLabel>Plan Name</MobileLabel>
                  </MobileCell>
                  <PlanNameText>{item.planName}</PlanNameText>
                </div>

                <div>
                  <MobileCell>
                    <MobileLabel>Description</MobileLabel>
                  </MobileCell>
                  <CellText>{item.description}</CellText>
                </div>

                <div>
                  <MobileCell>
                    <MobileLabel>Start Date</MobileLabel>
                  </MobileCell>
                  <CellText>{item.startDate ? moment(item.startDate).format("MM-DD-YYYY") : "-"}</CellText>
                </div>

                <div>
                  <MobileCell>
                    <MobileLabel>End Date</MobileLabel>
                  </MobileCell>
                  <CellText>{item.endDate ? moment(item.endDate).format("MM-DD-YYYY") : "-"}</CellText>
                </div>

                <div>
                  <MobileCell>
                    <MobileLabel>Status</MobileLabel>
                  </MobileCell>
                  <StatusBadge
                    variant={item.status === "Active" ? "active" : "inactive"}
                  >
                    {item.status}
                  </StatusBadge>
                </div>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <div>
                <CellText>No Membership Plan Found</CellText>
              </div>
            </TableRow>
          )}
        </MembershipTable>
      </MembershipContainer>
    </MembershipWrapper>
  );
};

export default MembershipPlan;
